import React, { useMemo, useState } from 'react';

import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';
import { Flex } from '@chakra-ui/react';
import { useQuery } from 'react-query';

import charitiesApi from 'api/charities';
import { FETCH_CHARITIES } from 'constants/queries';

import AppModal from '../AppModal';
import CharityDetailsEdit from '../CharityDetailsEdit';
import CharityFullDetails from '../CharityFullDetails';
import { MODE, CharityDetailsProps } from './CharityDetails.props';

const CharityDetailsView = (props: CharityDetailsProps): JSX.Element => {
  const { data: fullDetails, refetch } = useQuery(
    `${FETCH_CHARITIES}${props.id}`,
    () => (props.id ? charitiesApi.getDetails(props.id) : undefined)
  );

  const [mode, setMode] = useState(MODE.DEFAULT);

  const Content = useMemo(() => {
    if (!fullDetails) return <Flex />;

    if (mode === MODE.EDIT) {
      return (
        <CharityDetailsEdit
          refetch={refetch}
          onBack={() => setMode(MODE.DEFAULT)}
          data={fullDetails.charity}
        />
      );
    }

    return (
      <CharityFullDetails
        refetch={refetch}
        data={fullDetails}
        onSetMode={(m: MODE) => setMode(m)}
      />
    );
  }, [mode, fullDetails]);

  return (
    <AppModal
      {...props}
      size="5xl"
      onClose={() => {
        setMode(MODE.DEFAULT);
        props.onClose();
      }}
      onOverlayClick={props.onClose}
      title={fullDetails?.charity.name || '-'}
    >
      {!props.disableNext && (
        <Flex
          position="absolute"
          right="-150px"
          top="40vh"
          width="60px"
          height="60px"
          borderRadius="30px"
          zIndex="100"
          backgroundColor="#fff"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          onClick={props.onNext}
        >
          <ArrowRightIcon />
        </Flex>
      )}
      {!props.disablePrev && (
        <Flex
          position="absolute"
          left="-150px"
          top="40vh"
          width="60px"
          height="60px"
          borderRadius="30px"
          zIndex="100"
          backgroundColor="#fff"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          onClick={props.onPrev}
        >
          <ArrowLeftIcon />
        </Flex>
      )}
      {Content}
    </AppModal>
  );
};

export default CharityDetailsView;
